import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart_id: null,
  order_id: null,
  payment: null,
  payment_method: null,
  table: null,
  store: null,
  voucher: null,
  services: null,
  transaction_status: null,
  data: null,
  status: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    postCart: (state, { payload }) => {
      state.data = payload;
    },
    setCart: (state, { payload }) => {
      state.cart_id = payload;
    },
    setOrder: (state, { payload }) => {
      state.order_id = payload;
    },
    setPayment: (state, { payload }) => {
      state.payment = payload;
    },
    setPaymentMethod: (state, { payload }) => {
      state.payment_method = payload;
    },
    setStore: (state, { payload }) => {
      state.store = payload;
    },
    setTable: (state, { payload }) => {
      state.table = payload;
    },
    setServices: (state, { payload }) => {
      state.services = payload;
    },
    setVoucher: (state, { payload }) => {
      state.voucher = payload;
    },
    setTransactionStatus: (state, { payload }) => {
      state.transaction_status = payload;
    },
    resetOnLayanan(state) {
      state.order_id = null;
      state.table = null;
      state.services = null;
      state.payment = null;
      state.payment_method = null;
      state.cart_id = null;
      state.voucher = null;
      state.transaction_status = null;
    },
    resetAll(state) {
      state.store = null;
      state.order_id = null;
      state.table = null;
      state.services = null;
      state.payment = null;
      state.payment_method = null;
      state.cart_id = null;
      state.voucher = null;
      state.transaction_status = null;
    },
  },
});

export default cartSlice;
